module.exports = __webpack_public_path__ + "@/assets/img/check.29b9c1d2.svg";